import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { AuthService } from './auth.service';
import { activePermissionLevel } from '../utils/permission-level';

@Injectable({
  providedIn: 'root',
})
export class PermissionUtilityService {
  /**
   * WHOEVER IS SIGNED IN NOW (#94, 2026-10-26). This service is one instance for the whole app and used to copy the user
   * once, when it was created. Logout and login move between pages without a reload, so at a shared gate PC the next
   * person to log in kept the previous person's permissions until F5. The stored session is read on every check; the
   * parsed user is reused while the stored text is unchanged, so a page full of permission checks costs one parse.
   */
  get user(): User {
    const raw = localStorage.getItem('user');
    if (raw !== this.cachedRaw) {
      this.cachedRaw = raw;
      this.cachedUser = this.authService.getCurrentUserFromLocal();
    }
    return this.cachedUser!;
  }

  /** Kept for the callers that hand it the user they just read; the stored session stays the source of truth. */
  set user(user: User) {
    this.cachedUser = user;
    this.cachedRaw = localStorage.getItem('user');
  }

  private cachedRaw: string | null | undefined = undefined;
  private cachedUser: User | null = null;
  private permissionNames = [
    "DASHBOARD",
    "CARGO_CATEGORY",
    "CATEGORY",
    "CHECK_IN",
    "CLEARING_AGENT",
    "CLEARING_COMPANY",
    "CLIENT",
    "COMMODITY_CATEGORY",
    "COMMODITY_PACKAGING",
    "COMMODITY_WAREHOUSE",
    "COMMODITY",
    "COMPANY_SETTINGS",
    "CONTAINER_SIZE",
    "CONTAINER_TRANSACTION_TYPE",
    "CONTAINER_TRANSACTION_STATUS",
    "CONTAINER_TRANSACTION",
    "CONTAINER_TRANSPORTATION",
    "CURRENCY_RATE",
    "GRADE",
    "IMPORTER",
    "INTERNAL_WAREHOUSE_TRANSACTION",
    "LOAD_PORT",
    "LOAD_TYPE",
    "LOADING_BAY",
    "LOADING_FORMAT",
    "PACKAGING",
    "PAGINATED_RESULTS_MODEL",
    "PAGINATION_OPTIONS",
    "PARKING_BAY_SECTION",
    "PARKING_BAY",
    "PERMISSION_ROLE",
    "PERMISSION_USER",
    "PERMISSION",
    "PHYSICAL_EXAM_CATEGORY",
    "PHYSICAL_EXAMINATION_GROUP",
    "PHYSICAL_EXAMINATION",
    "PURPOSE",
    "RECONSTITUTION",
    "REPORT_OPTIONS",
    "ROLE",
    "SHIPPING_LINE",
    "SPECIAL_CONTAINER_CLIENT",
    "STACK",
    "TAG",
    "TOWN",
    "TRANSPORTER",
    "UNIT_OF_MEASURE",
    "USER_ACTIVITY",
    "USER",
    "WAREHOUSE_TRANSACTION_GROUP",
    "WAREHOUSE_TRANSACTION",
    "WAREHOUSE",
    "GATE_CONTROL_SHEET",
    "DAILY_RECONCILIATION_STATEMENT",
    "CLEARED_GATE_CONTROL_SHEET",
    "CLOSED_GATE_CONTROL_SHEET",
    "DAILY_STOCK_REPORT",
    "CLIENTS_MONTHLY_RENTAL_REPORT",
    "CONTAINERS_REPORT",
    "PHYSICAL_EXAMINATION_REPORT",
    "PHYSICAL_EXAMINATION_BY_CATEGORY",
    "PHYSICAL_EXAMINATION_BY_CONTAINER_SIZE",
    "STOCK_BY_WAREHOUSE",
    "STOCK_FOR_STACK",
    "STOCK_BY_BATCH_NUMBER",
    "STOCK_BY_CATEGORY",
  ];


  constructor(private authService: AuthService) {}



  checkPermissionsForSection(section: string, permission: number): boolean {
    const level = activePermissionLevel(this.user.permission_users, section);
    return level > 0 && level >= permission;
  }
}
